var React = require('react');

function ConfettiImg2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9201 15.0171L0.308594 4.11133L16.5873 0.93585L10.9201 15.0171Z","fill":"#46B47D"}));
}

ConfettiImg2.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = ConfettiImg2;

ConfettiImg2.default = ConfettiImg2;
